import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import DoDisturbAltOutlinedIcon from '@mui/icons-material/DoDisturbAltOutlined';
import { CreateForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import RejectForm from './forms/RejectForm/RejectForm';
import { Droppable } from 'framework/dnd';
import { foundationColors } from 'framework/ui/themes';
import useRecruitingBoardService from '../useRecruitingBoardService';
import { Stages } from 'domain/shared/candidate';

interface RejectBoxProps {
  id: string;
  activeNode: any;
}

const RejectBox: React.FC<RejectBoxProps> = ({ id, activeNode }) => {
  const { moveStage } = useRecruitingBoardService();
  const [sourceStage, setSourceStage] = useState<string | null>(null);
  const [isModalActive, setModalActive] = useState<boolean>(false);
  const [pendingItem, setPendingItem] = useState<any | null>(null);

  const closeDialog = () => {
    setModalActive(false);
    setPendingItem(null);
    setSourceStage(null);
  };

  return (
    <>
      {activeNode && activeNode.stage !== Stages.PendingRejection ? (
        <Droppable
          params={{
            canDrop: _args => {
              // Optional custom logic for determining if drop is allowed
              return true;
            },
            onDrop: ({ self, source }) => {
              const initialColumnName = source.data.stage;
              const applicationId = source.data.id as number;
              const version = source.data.version as number;
              const vacancyId = source.data.entityId as string;

              setPendingItem({ vacancyId, applicationId, version, targetStage: Stages.PendingRejection });
              setSourceStage(initialColumnName as string);
              setModalActive(true);
            },
          }}
          data={{ id }} // Optional data to associate with the droppable area
        >
          {({ isDraggedOver, droppableRef }) => (
            <Box
              ref={droppableRef}
              width="200px"
              height="100px"
              position="fixed"
              bottom={10}
              left="92%"
              zIndex={998}
              sx={{ opacity: 0.7, transform: 'translateX(-50%)' }}
            >
              <Box
                height="100px"
                padding="20px 5px"
                bgcolor={isDraggedOver ? foundationColors.errorStrongSurface : 'background.error'}
                border={2}
                borderColor="border.error"
                borderRadius={0.75}
                textAlign="center"
                sx={{
                  borderStyle: 'dashed',
                  transition: 'background-color 0.3s, box-shadow 0.3s',
                }}
              >
                <DoDisturbAltOutlinedIcon
                  color="error"
                  sx={{
                    fontSize: isDraggedOver ? '2.5rem' : '2rem',
                    transition: 'transform 0.3s ease, font-size 0.3s ease',
                    transform: isDraggedOver ? 'scale(1.3)' : 'scale(1)',
                  }}
                />

                <Typography variant="h6" color="error">
                  Reject
                </Typography>
              </Box>
            </Box>
          )}
        </Droppable>
      ) : null}
      {isModalActive ? (
        <Modal
          isOpen
          key="modal-not-strict"
          modalSize="sm"
          backdrop="static"
          title="Additional info required"
          onToggle={closeDialog}
        >
          <CreateForm
            submitFormFunc={formData => {
              if (pendingItem) {
                return moveStage(
                  pendingItem.vacancyId,
                  pendingItem.version,
                  pendingItem.applicationId,
                  pendingItem.targetStage,
                  formData,
                );
              } else {
                return Promise.reject();
              }
            }}
            afterSubmit={{
              execute: () => {
                setPendingItem(null);
                setModalActive(false);
                setSourceStage(null);
              },
            }}
          >
            <RejectForm handleCancelClick={closeDialog} sourceStage={sourceStage as string} />
          </CreateForm>
        </Modal>
      ) : null}
    </>
  );
};

export default RejectBox;
